import { httpsCallable } from 'firebase/functions';
import { functions } from '../utils/firebase-config';

const invoke = async (name, data) => (await httpsCallable(functions, name)(data)).data;
export const createContactTicket = data => invoke('createContactTicket', data);
export const sendContactTicketMessage = data => invoke('sendContactTicketMessage', data);

// Callable JSON transports ISO dates, while the existing ticket UI uses Timestamp methods.
const timestamp = value => value ? { toDate: () => new Date(value), toMillis: () => new Date(value).getTime() } : null;
export const trackContactTicket = async credentials => {
  const result = await invoke('trackContactTicket', credentials);
  return { ticket: { ...result.ticket, createdAt: timestamp(result.ticket.createdAt) },
    messages: result.messages.map(message => ({ ...message, createdAt: timestamp(message.createdAt) })) };
};

export const uploadTicketFiles = async (files, ticketId, credentials = {}) => {
  const uploaded = [];
  for (const file of files) {
    const base64 = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result).split(',')[1]);
      reader.onerror = () => reject(new Error('Unable to read the attachment.'));
      reader.readAsDataURL(file);
    });
    uploaded.push(await invoke('uploadTicketAttachment', { ticketId, ...credentials,
      name: file.name, type: file.type, base64 }));
  }
  return uploaded;
};
